import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const CloudPlanContext = createContext({
    currentCloudPlan: 1,
    setGlobalCloudPlan: () => {}
});

export function CloudPlanProvider({ children }) {
    const [currentCloudPlan, setGlobalCloudPlan] = useState(1);

    const value = useMemo(
        () => ({
            currentCloudPlan,
            setGlobalCloudPlan
        }),
        [currentCloudPlan]
    );

    return <CloudPlanContext.Provider value={value}>{children}</CloudPlanContext.Provider>;
}

CloudPlanProvider.propTypes = {
    children: PropTypes.node.isRequired
};
